export const profileContactList = {
	wrapper: {
		// paddingTop: '20px',
	},

	avatarContainer: {
		marginBottom: '24px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},

	avatarImage: {
		width: '100%',
		maxWidth: '100px',
		marginBottom: '16px',
		'& img': {
			width: '100%',
		},
	},

	btn: {
		padding: '10px 16px',
		'&:first-of-type': {
			marginRight: '16px',
		},
	},

	red: {
		color: 'var(--error-500)',
		'&:hover': {
			color: 'var(--error-400)',
		},
	},

	widget: {
		padding: '16px',
		border: '1px solid var(--neutral-100)',
		borderRadius: '8px',
		background: 'var(--neutral-50)',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: '24px',
	},

	widgetTitle: {
		fontSize: '16px',
		color: 'var(--neutral-900)',
	},

	secondaryText: {
		color: 'var(--neutral-500)',
		fontSize: '14px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 200px',
			width: '100%',

			'@media (max-width: 1199.98px)': {
				padding: '48px 80px',
			},

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},

	customeModal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			paddingTop: '48px',
			width: '100%',
		},
	},

	loaderWrap: {
		minHeight: '300px',
		display: 'flex',
		alignItemas: 'center',
		justifyContent: 'center',
	},
	twoStep: {
		maxWidth: '496px',
		lineHeight: '143%',
	},
};
